export default function (props: any) {
    return (
        <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M5.75 0v4.25H10v1.5H5.75V10h-1.5V5.75H0v-1.5h4.25V0h1.5z" fill="currentColor" fillRule="evenodd" />
        </svg>
    );
}
